<template>
  <div>
    <div class="wreppar">
      <div class="headers">
        <Header></Header>
      </div>
      <div class="centent">
        <div class="center">
          <div class="centent_left">
            <div class="center_top">
              <div>
                <p class="center_guan">关于我们</p>
                <p>十九路赛事网是个专门用于围棋的、集赛事在线报名、在线支付、在线实时对阵发布为一体的一站式赛事服务平台。</p>
                <p class="center_guan">我们的市场</p>
                <p>所有从事围棋相关的行业</p>
              </div>
              <div class="centent_logo">
                <img src="../../assets/us1.jpg" alt />
              </div>
            </div>
            <div class="centent_wen">
              <div class="shi_img">
                <img src="../../assets/us2.jpg" alt />
              </div>
              <div>
                <p class="center_guan">我们的文化</p>
                <p>企业文化： 诚信、踏实、优质、一流！</p>
                <p>经营理念： 追求卓越无止境、与时俱进创未来！</p>
                <p>价值观念： 追求价值是我们工作的起点、创造价值是我们人生的动力！</p>
                <p>实现价值是我们恒久的追求！ 创业激情： 人生追求没句号、自古爱拼才会赢！</p>
                <p>创业动力： 用爱心做事业、用感恩的心做人</p>
              </div>
            </div>
          </div>
          <div class="centent_right">
            <div class="re_dian">
              <p class="dian_shi">十九路</p>
              <p class="dian_wen">MORE</p>
            </div>
            <div class="dian_center">
              <p>关于我们</p>
              <p>联系我们</p>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>  
<script >
import Header from "../header/header.vue";
import Footer from "../footer/footer.vue";
export default {
  data() {
    return {};
  },
  components: { Header, Footer },
  watch: {},
  mounted() {},
  methods: {}
};
</script>
<style scoped="scoped">
* {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.wreppar {
  width: 100%;
  cursor: default;
}
.headers {
  width: 100%;
}
.centent {
  width: 100%;
  padding-top: 1.85rem;
  margin-bottom: 0.6rem;
}
.center {
  width: 76%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.centent_left {
  width: 71%;
}
.center_top {
  margin-top: 0.4rem;
  font-size: 0.2rem;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.center_top p {
  margin-top: 0.2rem;
}
.center_top .center_guan {
  font-size: 0.24rem;
  font-weight: bold;
}
.centent_wen {
  display: flex;
  justify-content: flex-start;
  font-size: 0.2rem;
  margin-top: 0.3rem;
}
.centent_wen .center_guan {
  font-size: 0.24rem;
  font-weight: bold;
  margin-bottom: 0.1rem;
}
.centent_logo {
  width: 2rem;
  height: 2rem;
  position: absolute;
  top: 1rem;
  right: 0;
}
.centent_logo img {
  width: 2rem;
  height: 2rem;
}
.re_dian {
  width: 100%;
  border-bottom: solid 2px #e50005;
  display: flex;
  justify-content: space-between;
}
.dian_shi {
  font-size: 0.2rem;
  background: #e50005;
  line-height: 0.4rem;
  color: #fff;
  padding: 0 0.3rem;
  border-radius: 5px 5px 0 0;
}
.dian_wen {
  font-size: 0.2rem;
  color: #e50005;
  line-height: 0.4rem;
}
.dian_center {
  width: 100%;
}
.dian_center p {
  font-size: 0.2rem;
  line-height: 1rem;
  border-bottom: solid 1px #ccc;
}
.centent_right {
  width: 26%;
  margin-top: 0.6rem;
}
.shi_img {
  width: 3.1rem;
  height: 1.6rem;
}
.shi_img img {
  width: 3.1rem;
  height: 1.8rem;
}
</style>  


// WEBPACK FOOTER //
// src/components/page/about.vue